import React, { useEffect, useState } from "react";
import { AA } from "@/constants/testIds";
import { List, X } from "@phosphor-icons/react";

const links = [
  { id: "services", label: "Services", testId: AA.navServices },
  { id: "drone", label: "Drone", testId: AA.navDrone },
  { id: "quote", label: "Quote", testId: AA.navQuote },
  { id: "contact", label: "Contact", testId: AA.navContact },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A0A0A]/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <button
          onClick={() => go("top")}
          data-testid={AA.navLogo}
          className="flex items-center gap-3 group"
          aria-label="Aerial Alignment Home"
        >
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" className="text-[#FF4500]">
            <circle cx="14" cy="14" r="12.5" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="14" cy="14" r="5" stroke="currentColor" strokeWidth="1.2" />
            <line x1="14" y1="0" x2="14" y2="28" stroke="currentColor" strokeWidth="1" />
            <line x1="0" y1="14" x2="28" y2="14" stroke="currentColor" strokeWidth="1" />
            <circle cx="14" cy="14" r="1.4" fill="currentColor" />
          </svg>
          <div className="font-display font-black text-white text-[15px] tracking-tight leading-none">
            AERIAL<br />
            <span className="text-[#FF4500]">ALIGNMENT</span>
          </div>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => go(l.id)}
              className="font-mono text-[11px] tracking-[0.22em] uppercase text-white/70 hover:text-[#FF4500] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden md:block">
          <button
            data-testid={AA.navCtaQuote}
            onClick={() => go("quote")}
            className="aa-btn aa-btn-primary btn-traced"
          >
            Get Quote <span aria-hidden>→</span>
          </button>
        </div>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={22} weight="bold" /> : <List size={22} weight="bold" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0A0A] border-t border-white/10">
          <div className="px-6 py-5 flex flex-col gap-4">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testId}-mobile`}
                onClick={() => go(l.id)}
                className="text-left font-mono text-xs tracking-[0.2em] uppercase text-white/80"
              >
                {l.label}
              </button>
            ))}
            <button
              onClick={() => go("quote")}
              className="aa-btn aa-btn-primary w-full justify-center mt-2"
            >
              Get Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
